import { PaymentIntegrationEnumDto } from 'apps/public-portal/src/app/core/api/PublicPortalApiClients';

/**
 * Processors that complete payment via an external redirect rather than an
 * inline form.
 *
 * This is the source of truth for the {@link isRedirectProcessor} predicate.
 * It is deliberately kept free of any service-class imports so that consumers
 * needing only the redirect check (e.g. the admin portal's config screens) do
 * not pull the entire PaymentProcessorProvider class map — and through it every
 * integration component — into their compilation.
 *
 * Keep in sync with the `static override redirect = true` declarations on the
 * corresponding integration services (see the class map in
 * payment-processor.provider.ts; "when adding a new integration, add it here").
 */
export const REDIRECT_PROCESSORS: ReadonlySet<PaymentIntegrationEnumDto> = new Set([
    PaymentIntegrationEnumDto.Govolution,
    PaymentIntegrationEnumDto.InvoiceCloud,
    PaymentIntegrationEnumDto.LexisNexis,
    PaymentIntegrationEnumDto.Nic,
    PaymentIntegrationEnumDto.Paymentus,
    PaymentIntegrationEnumDto.PointAndPay,
]);

/**
 * True when the processor completes payment via an external redirect.
 * Can be used without instantiating PaymentProcessorProvider.
 */
export function isRedirectProcessor(processor: PaymentIntegrationEnumDto): boolean {
    return REDIRECT_PROCESSORS.has(processor);
}
